module.exports = __webpack_public_path__ + "media/src/assets/Images/GaragePNG-c3e2ef85dfc78e9af8d2a25d6ad47d8d.png";